import { colors } from "../../../../data/colors";
import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";
import { updateStationaryItem } from "./updateStationaryItem";

export const callStationeryImages = async (code: number, params: stdObject) => {
  const {
    t,
    setModalData2,
    setMsg2,
    closeMsg,
    staValues,
    setStaValues,
    logoutAction,
  } = params;

  setMsg2("loading");
  const responseSaveStationery: stdObject = await sendData({
    endPoint: "callStationeryImages",
    logoutAction,
  });
  console.log("responseSaveStationery", responseSaveStationery);
  if (responseSaveStationery.success && responseSaveStationery.status) {
    setMsg2("custom2");
    setModalData2({
      title: t("p.stationeryImages"),
      imagesList: {
        selectImage: (value: string) => {
          updateStationaryItem(
            code,
            {
              IMGPAR: value,
            },
            { staValues, setStaValues },
          );
          closeMsg(2);
          setModalData2({});
        },
        images: Object.values(responseSaveStationery.images),
      },
      buttons: [
        {
          label: t("p.cancel"),
          onClick: () => closeMsg(2),
          color: colors.darkGrey,
        },
      ],
    });
  } else {
    setMsg2("error");
  }
  return;
};
